
/**
 * Use this class to process data for smart points
 */
export default class SmartPointModel {
  id = Number
  name = String
  address = String
  country = String
  latitude = Number
  longitude = Number
  postalCode = Number
  city = String
  image = String
  note = String
  title = String
  type = String
  email = String
  workingHours = String

  constructor (smartPointObject = {}) {
    this.id = smartPointObject.id || 0
    this.name = smartPointObject.name || ''
    this.address = smartPointObject.address || ''
    this.country = smartPointObject.country || ''
    this.latitude = smartPointObject.latitude || 0
    this.longitude = smartPointObject.longitude || 0
    this.postalCode = smartPointObject.postalCode || 0
    this.city = smartPointObject.city || ''
    this.image = smartPointObject.image || ''
    this.note = smartPointObject.note || ''
    this.title = smartPointObject.title || ''
    this.type = smartPointObject.type || ''
    this.email = smartPointObject.email || ''
    this.workingHours = smartPointObject.workingHours || ''
  }
}
